import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-showtoast',
  templateUrl: './showtoast.component.html',
  styleUrls: ['./showtoast.component.css']
})
export class ShowtoastComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
